<template>
  <div class="hardWare">
    <div>
      <img src="./hardWare1.png" alt="" class="width100">
    </div>
     <div class="banner">
        <div class="imgCourBg"><img src="./hardWare2.png" alt=""></div>
       <indexHomeTit :desc="desc"></indexHomeTit>
       <div class="text-center por">
         <img src="./hardWare3.png" alt="中药堂预约挂号一体机" class="Img minImg">
         <div class="word colorfff">
           <p>核心软件：云标预约挂号系统1.0</p>
           <p>主要功能：预约挂号、取号、医生信息查询、店铺地图、按病寻医、电子病历</p>
           <p>硬件信息：21.5英寸自助机</p>
           <p>运行系统：android,8核，2G内存，8G存储</p>
           <p>配置：身份证识别仪    热敏小票打印机</p>
           <p> wifi模块    4G模块（推荐）人脸识别   智能语音</p>
         </div>
       </div>
     </div>
    <div class="banner">
      <div class="imgCourBg"><img src="./hardWare2.png" alt=""></div>
       <indexHomeTit :desc="desc1"></indexHomeTit>
       <div class="text-center por">
         <img src="./hardWare7.png" alt="排队叫号显示屏" class="Img minImg">
         <div class="word colorfff">
           <p>核心软件：云标排队叫号显示系统</p>
           <p>主要功能：排队信息、实时叫号、通知公告、信息发布</p>
           <p>运行系统：android,8核，2G内存，8G存储</p>
           <p>硬件信息：55寸/65寸壁挂广告机</p>
           <p>分辨率：1920*1080px，可视角度：178</p>
           <p>配置：叫号器</p>
         </div>
       </div>
    </div>
    <div class="banner">
      <div class="imgCourBg"><img src="./hardWare2.png" alt=""></div>
       <indexHomeTit :desc="desc2"></indexHomeTit>
       <div class="text-center por">
         <img src="./hardWare8.png" alt="资源快速发布上屏" class="Img minImg">
         <div class="word colorfff" style="margin: 60px 0 0;">
           <p>核心软件：云标触摸查询系统</p>
           <p>主要功能：医院导视、医师介绍、科室介绍、医生出诊排班信息</p>
           <p>硬件信息：42寸/50寸/55寸/立式广告机</p>
           <p>运行系统：android,8核，2G内存，8G存储</p>
           <p>分辨率：1920*1080px，可视角度：178</p>
           <p>触摸介质：电容/红外</p>
         </div>
       </div>
    </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import indexHomeTit from '../indexhometit/indexhometit.vue';
  export default {
    components: {
      indexHomeTit
    },
    data() {
      return {
        desc: '自助服务终端',
        desc1: '排队叫号显示端',
        desc2: '自助触摸查询端'

      }
    }
  };
</script>

<style lang="stylus" rel="stylesheet/stylus">
.hardWare
  .indexHomeTit
    background-size 400px
    margin-top 60px
    margin-bottom 50px
  .banner
    position: relative
    padding: 55px 0 20px
    overflow: hidden;
    .imgCourBg
      width 100%
      position: absolute
      bottom:0
      left:0
      z-index -1
    .item
      text-align center
      .word
        height 270px
        margin-top 20px
        font-size: 24px
      .Img
        margin:0 auto
    .carousel-control
      background-image linear-gradient(to right, rgba(0, 0, 0, .0) 0%, rgba(0, 0, 0, .0) 100%);
      &.right
        right 0
      img
        position: absolute
        top:50%
        left: 0;
@media (min-width: 320px) and (max-width: 750px)
  .hardWare
    .indexHomeTit
      background-size 100%
      margin: 15px auto;
    .banner
      .carousel-control img
        width 80%
      .imgCourBg
        overflow: hidden
        bottom: -95px
      .item
        .word
          font-size: 16px
    .minImg
      width 100%


</style>



// WEBPACK FOOTER //
// src/components/hardware/hardware.vue